import React from 'react';
import { createIcon } from './create-icon';
import './icon-attach-to-sheet-blue.scss';

export const IconAttachToSheetBlue = createIcon(<div className="icon-attach-to-sheet-blue" />);
